import { useState } from "react";
import { Building2, Truck, Layers, ScrollText } from "lucide-react";
import DocumentsPage from "@/components/DocumentsPage";
import ClinicLegalTemplatesSection from "@/components/admin/ClinicLegalTemplatesSection";

const TABS = [
  { id: "clinic", label: "Clinic Documents", icon: Building2, role: "clinic",
    description: "Clinic-side agreements, BAAs, compliance docs, and the Nodera legal-template library." },
  { id: "vendor", label: "Vendor Documents", icon: Truck, role: "vendor",
    description: "Vendor contracts, certificates of insurance, licensure attestations, and SLAs." },
  { id: "all", label: "All", icon: Layers, role: null,
    description: "Everything across clinic, vendor, and admin uploads — the full network registry." },
];

export default function AdminDocuments() {
  const [tab, setTab] = useState("clinic");
  const active = TABS.find((t) => t.id === tab) || TABS[0];

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center gap-2" data-testid="admin-documents-tabs">
        {TABS.map((t) => {
          const isActive = t.id === tab;
          return (
            <button
              key={t.id}
              type="button"
              onClick={() => setTab(t.id)}
              data-testid={`admin-documents-tab-${t.id}`}
              className={`inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-xs font-semibold border transition-colors ${
                isActive
                  ? "bg-slate-900 text-white border-slate-900"
                  : "bg-white text-slate-700 border-slate-200 hover:border-slate-400"
              }`}
            >
              <t.icon className="w-3.5 h-3.5" />
              {t.label}
            </button>
          );
        })}
      </div>

      <DocumentsPage
        key={tab}
        accent="violet"
        eyebrow={`Admin · Documents · ${active.label}`}
        title={active.label === "All" ? "Document registry" : active.label}
        description={active.description}
        ownerRoleFilter={active.role}
        footerSlot={
          tab === "clinic" ? (
            <div className="pt-6" data-testid="admin-documents-legal-templates-section">
              <div className="flex items-center gap-2 mb-3">
                <ScrollText className="w-4 h-4 text-violet-700" />
                <h2 className="font-display text-xl font-bold text-slate-900">
                  Nodera legal templates
                </h2>
              </div>
              <p className="text-sm text-slate-600 max-w-2xl mb-4">
                Five reference contracts that codify Nodera's positioning — operational
                infrastructure only, no clinical role, no fund custody, and clinic-retained
                data ownership. Read, copy plaintext, or download markdown for attorney review.
              </p>
              <ClinicLegalTemplatesSection />
            </div>
          ) : null
        }
      />
    </div>
  );
}
